import { render, staticRenderFns } from "./list.vue?vue&type=template&id=be280f94&"
import script from "./list.ts?vue&type=script&lang=ts&"
export * from "./list.ts?vue&type=script&lang=ts&"
import style0 from "../orgMgr.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports